import React, { useEffect, useRef, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Editor } from '@tinymce/tinymce-react';
import { Button } from '@mui/material';
import Select from 'react-select';
import { email, renderField, required } from '../../common/helpers/form-validations';
import { emailAccountList } from '../../Services/Utils/EmailNotificationApis';

export const renderEmailAccountSelect = (props) => (
  <div>
    <Select
      {...props}
      className="react-select__container"
      classNamePrefix="react-select"
      value={props.input.value}
      onChange={(value) => props.input.onChange(value)}
      onBlur={() => props.input.onBlur()}
      options={props.options}
      isSearchable={false}
      getOptionLabel={(e) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginLeft: 5 }}>{e.text}</span>
        </div>
      )}
      styles={{
        control: (base) => ({
          ...base,
          border: '1px solid #CBCBCB',
          boxShadow: 'none',
          '&:hover': {
            border: '1px solid black',
          }
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? '#DDDDDD' : 'white',
          color: '#000000'
        })
      }}
    />
    {props.meta.touched && (props.meta.error && (
      <span className="text-danger small">
        <i className="fa fa-exclamation-circle text-danger" />&nbsp;&nbsp;{props.meta.error}
      </span>
    ))}
  </div>
);

export const renderContentEditor = (props) => {
  const editorRef = useRef(null);
  return (
    <div>
      <Editor
        {...props}
        name="content"
        apiKey="j93rzdca1a2adc2hyca4ely4yjt7jxog35wum3e7c97vdtbp"
        value={props.input.value}
        onEditorChange={(e) => props.input.onChange(e)}
        onInit={(evt, editor) => { editorRef.current = editor; }}
        init={{
          height: 500,
          menubar: false,
          selector: 'textarea',
          plugins: [
            // 'advlist autolink lists link image charmap print preview anchor',
            // 'searchreplace visualblocks code fullscreen',
            // 'insertdatetime media table paste code wordcount ',
            // 'code ',
          ],
          toolbar: 'undo redo | blocks fontfamily fontsize |'
          + 'bold italic backcolor |  alignleft aligncenter '
          + 'alignright alignjustify | bullist numlist outdent indent '
          + 'removeformat | ',
          // + 'code ',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
      />
      {props.meta.touched && (props.meta.error && (
        <span className="text-danger small">
          <i className="fa fa-exclamation-circle text-danger" />&nbsp;&nbsp;{props.meta.error}
        </span>
      ))}
    </div>
  );
};

function EmailContentForm(props) {
  const {
    mainText, submitText, handleSubmit, onSubmitFunction,
    notificationName, submitSucceeded, invalid, pristine,
  } = props;

  const [emailAccountOptions, setEmailAccountOptions] = useState();

  useEffect(() => {
    const params = { start: 0, recordSize: '' };
    emailAccountList({}, params).then((res) => {
      const options = [];
      res.list.map((data) => {
        options.push({
          id: data.id,
          label: data.name,
          text: data.name,
          value: data.name
        });
      });
      setEmailAccountOptions(options);
    });
  }, []);

  const onSubmit = (formData) => {
    onSubmitFunction(formData);
  };
  return (
    <div style={{ margin: '50px', width: '700px' }}>
      <h6>{mainText}</h6>
      <p>{`(${notificationName})`}</p><br />
      <form
        form="emailContentForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 margin-50px">
            <div className="form-group">
              <label htmlFor="emailName">
                Email Account <span className="validation-icon">*</span>
              </label>
              <Field
                type="dropdown"
                id="emailName"
                className="form-control"
                component={renderEmailAccountSelect}
                name="emailAccountView"
                options={emailAccountOptions}
                validate={[required]}
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">
                Subject <span className="validation-icon">*</span>
              </label>
              <Field
                id="subject"
                className="form-control"
                placeholder="Enter here"
                component={renderField}
                name="subject"
                validate={[required]}
              />
            </div>
            <div className="form-group">
              <label htmlFor="emailBcc">
                Email Bcc
              </label>
              <Field
                id="emailBcc"
                className="form-control"
                placeholder="abc@xyz.com"
                component={renderField}
                name="emailBcc"
                validate={[email]}
              />
            </div>
            <div className="form-group">
              <label htmlFor="emailCc">
                Email Cc
              </label>
              <Field
                id="emailCc"
                className="form-control"
                placeholder="abc@xyz.com"
                component={renderField}
                name="emailCc"
                validate={[email]}
              />
            </div>
            <div className="form-group">
              <label htmlFor="emailContent">
                Content <span className="validation-icon">*</span>
              </label>
              <Field
                type="textarea"
                id="emailContent"
                className="form-control"
                component={renderContentEditor}
                name="emailContent"
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <Button
                className="btn btn-red"
                type="submit"
                disabled={submitSucceeded || invalid || pristine}
              >
                {submitText}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'emailContentForm',
});

export default withForm(EmailContentForm);
